module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"empty_state":{"action":"To the tool tip","empty_state":"Have you already completed your profile?<br/>Complete your profile for more trustworthiness and have it verified to activate new functions.<b/> You can find out more about this in this tool tip.","title":"This member has not yet introduced themselves."}}}}}}}')
  delete Component.options._Ctor
}
